import { memo } from "react";

import { IconApi, IconApps } from "@tabler/icons";
import { useTheme } from "styled-components";

import { Dialog } from "@sso/constant";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { openApiKeysTable } from "@sso/store/slices/apiAccount";
import { openDialog } from "@sso/store/slices/dialog";
import { RowContainer } from "@sso/ui/FlexBox";
import { IconButton } from "@sso/ui/IconButton";
import { TD } from "@sso/ui/Table";

interface UserTableActionsProps {
  apiAccountId: string;
}

export const APIAccountsTableActions = memo(({ apiAccountId: id }: UserTableActionsProps) => {
  const theme = useTheme();
  const dispatch = useAppDispatch();

  const handleOpenApiKeysTable = () => dispatch(openApiKeysTable(id));
  const handleAccountProduct = () => dispatch(openDialog({ type: Dialog.API_ACCOUNT_PRODUCT, id }));

  return (
    <TD>
      <RowContainer justify="center">
        <IconButton
          title="Apps"
          color={theme.colors.grey[400]}
          hoverColor={theme.colors.grey[700]}
          onClick={handleAccountProduct}
        >
          <IconApps />
        </IconButton>
        <IconButton
          title="API Tokens"
          color={theme.colors.grey[400]}
          hoverColor={theme.colors.grey[700]}
          onClick={handleOpenApiKeysTable}
        >
          <IconApi size={28} />
        </IconButton>
      </RowContainer>
    </TD>
  );
});
